import { render } from "./BookmarkPagesModal.vue?vue&type=template&id=a90500c2&scoped=true"
import script from "./BookmarkPagesModal.vue?vue&type=script&lang=js"
export * from "./BookmarkPagesModal.vue?vue&type=script&lang=js"

import "./BookmarkPagesModal.vue?vue&type=style&index=0&id=a90500c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90500c2"]])

export default __exports__